import AlchemyModal, { ModalBody, ModalFooter, ModalHeader } from 'UIKit/AlchemyModal'
import Button from 'UIKit/Button'
import { ModalProps } from 'UIKit/Modal'
import Text from 'UIKit/Text'
import Column, { ColumnCenter } from 'layout/Components/Column'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ModalColorTheme } from 'theme/modal/colors'
import { isCashbackBonus } from 'utils/bonus'

const WarningCashbackBonusModal: React.FC<ModalProps<{ cashbackBonus: any; onActiveBonusSubmitted: () => void }>> = ({
  onDismiss,
  data: { cashbackBonus, onActiveBonusSubmitted },
}) => {
  const { t } = useTranslation()

  const handleSubmitActive = async () => {
    onActiveBonusSubmitted()
    onDismiss()
  }
  return (
    <AlchemyModal
      colorTheme={ModalColorTheme.Darkblue}
      title={t('There is an actived bonus')}
      maxWidth={'425px !important'}
      minWidth={'unset !important'}
    >
      <ModalHeader colorTheme={ModalColorTheme.Darkblue} title={t('Confirm Bonus Activation')} titleAlign={'left'} />
      <ModalBody>
        <Column>
          <Description>
            <Trans>
              Activating this bonus will give you boosted rewards, but it will disable your Regular Cashback for any
              affected period
            </Trans>
            .
          </Description>
          <Description mt="4px">
            <Trans>Are you sure you want to continue</Trans>?
          </Description>
        </Column>
      </ModalBody>

      <ModalFooter>
        <ColumnCenter width="100%">
          {isCashbackBonus(cashbackBonus) ? (
            <StyledButton onClick={handleSubmitActive}>
              <Trans>Yes, active now</Trans>
            </StyledButton>
          ) : (
            <StyledButton onClick={handleSubmitActive}>
              <Trans>Continue to deposit</Trans>
            </StyledButton>
          )}
          <StyledButton variant="text" onClick={onDismiss}>
            <Trans>Cancel</Trans>
          </StyledButton>
        </ColumnCenter>
      </ModalFooter>
    </AlchemyModal>
  )
}

const StyledButton = styled(Button)`
  font-size: 14px;
  font-weight: 600;
  width: 100%;
`

const Description = styled(Text)`
  color: ${({ theme }) => theme.colors.textSubtle};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.28px;
`

export default WarningCashbackBonusModal
